import script from "./CompanyList.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyList.vue?vue&type=script&setup=true&lang=js"

import "./CompanyList.vue?vue&type=style&index=0&id=390e9b08&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390e9b08"]])

export default __exports__